<template>
  <div>
    <FilterCommon :model="model" :isAdd="false" @search="search" :isReset="true" @reset="reset">
      <template v-slot:button>
        <el-button type="primary" @click="batchCheck" v-if="batchShow">批量质检</el-button>
        <!-- 新增超时配置和更新超时配置状态的按钮 按钮权限显示字段同批量质检 -->
        <el-button type="primary" @click="overTimeSet" v-if="batchShow">超时配置</el-button>
        <!-- <el-button type="primary" @click="updateOverTime" v-if="batchShow">更新超时状态</el-button> -->
      </template>
    </FilterCommon>
    <el-table border v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50" />
      <el-table-column prop="account" label="账号">
        <template slot-scope="scope">
          <el-link type="primary" @click="chooseAcc(scope.row)">{{ scope.row.account }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="total_money" label="总充值" />
      <el-table-column prop="staff_name" label="接待客服" />
      <el-table-column prop="nickname" label="客服昵称" />
      <el-table-column prop="game_tag" label="游戏标签" />
      <el-table-column prop="chat_at" label="会话开始时间" />
      <el-table-column prop="first_request_at" label="首次来访时间" />
      <el-table-column prop="first_response_at" label="首次响应时间" />
      <el-table-column prop="channel_text" label="渠道" />
    </el-table>
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

    <Drawer ref="drawer" @refresh="refresh"></Drawer>
    <Dialog ref="dialog" @submitForm="dialogSure" @closeDialog="closeDialog" :dialogTitle="'批量质检'" :dialogVisible="dialogVisible" :dialogModel="dialogModel" dialogWidth="700px"></Dialog>
  </div>
</template>

<script>
import Drawer from '../component/Drawer';
import Dialog from '@/components/common/Dialog';
import FilterCommon from '@/components/common/Filter';
import Pagination from '@/components/pagination/index';
import { getInspectionList, batchSaveCheckResult } from '@/api/vipQualityTest';
import dayjs from 'dayjs';

export default {
  components: {
    FilterCommon,
    Pagination,
    Drawer,
    Dialog,
  },
  props: {
    options: {
      type: Object,
      default: function () {
        return {
          admin: [],
          channel: [],
          check: [],
          nickname: [],
          result: [],
          tag: [],
          time: [],
        };
      },
    },
  },
  data() {
    return {
      listLoading: false,
      tableData: [],
      total: 0,
      listQuery: {
        is_checked: 0,
        page: 1,
        limit: 10,
        start_time: dayjs(new Date() - 1000 * 60 * 60 * 24 * 7).format('YYYY-MM-DD'),
        end_time: dayjs(new Date()).format('YYYY-MM-DD')
      },
      selectArr: [],
      batchShow: false,
      dialogVisible: false,
      dialogModel: [
        {
          type: 'el-radio',
          label: '质检结果',
          prop: 'check_result',
          options: [
            { label: 1, text: '合格' },
            { label: 2, text: '不合格' },
            { label: 3, text: '提醒' },
          ],
        },
        {
          type: 'el-input-textarea',
          label: '备注',
          prop: 'remark',
        },
      ],
    };
  },
  computed: {
    model() {
      return [
        {
          type: 'input',
          label: '账号',
          key: 'account',
          span: 4,
        },
        {
          type: 'input',
          label: '接待客服',
          key: 'staff_name',
          span: 4,
        },
        {
          type: 'input',
          label: '游戏标签',
          key: 'game_tag',
          span: 4,
        },
        {
          type: 'select',
          label: '渠道',
          key: 'channel',
          placeholder: '请选择渠道',
          span: 4,
          options: this.options.channel,
        },
        {
          type: 'select',
          label: '昵称',
          key: 'nickname',
          placeholder: '请选择昵称',
          span: 4,
          options: this.options.nickname,
        },
        {
          span: 5,
          type: 'date-picker',
          label: '会话时间',
          key: 'date',
          dateType: false,
          empty: false,
          pick: true,
          showDayWeek:true
        },
        {
          span: 5,
          type: 'date-picker',
          label: '首次响应时间',
          key: 'response_time',
          dateType: false,
          empty: false,
          pick: true,
        },
        {
          span: 6,
          type: 'select',
          label: '首次响应时间00',
          key: 'zero_response_time',
          options: [
            { label: '是', id: '1' },
            { label: '否', id: '0' },
          ],
        },
        {
          span: 7,
          type: 'select',
          label: '首次来访时间00',
          key: 'zero_request_time',
          options: [
            { label: '是', id: '1' },
            { label: '否', id: '0' },
          ],
        },
      ];
    },
  },
  created() {
    this.getList(this.listQuery);
  },
  methods: {
    // 获取列表数据
    async getList(query) {
      this.listLoading = true;
      const { data } = await getInspectionList(Object.assign(this.listQuery, query));
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.tableData = data.data.data;
      this.total = data.data.total;
      this.batchShow = data.data.batch_check_button;
      this.listLoading = false;
    },
    search(data) {
      if (!data.start_date) {
        Object.assign(data, {
          start_date: dayjs(new Date() - 1000 * 60 * 60 * 24 * 7).format('YYYY-MM-DD')
        })
      }
      if (!data.end_date) {
        Object.assign(data, {
          end_date: dayjs(new Date()).format('YYYY-MM-DD')
        })
      }
      Object.assign(this.listQuery, data, {
        start_time: data.start_date,
        end_time: data.end_date,
        response_start_time: data.response_time ? data.response_time[0] : '',
        response_end_time: data.response_time ? data.response_time[1] : '',
      });
      delete this.listQuery.start_date;
      delete this.listQuery.end_date;
      delete this.listQuery.date;
      delete this.listQuery.response_time;
      this.getList(this.listQuery);
    },
    reset() {
      this.listQuery = {
        is_checked: 0,
        page: 1,
        limit: 10,
      };
    },
    chooseAcc(row) {
      this.$refs.drawer.chooseAcc(row);
    },
    refresh() {
      this.getList(this.listQuery);
    },
    handleSelectionChange(val) {
      const arr = [];
      val.forEach((item) => {
        arr.push(item.id);
      });
      this.selectArr = arr;
    },
    // 点击批量质检
    batchCheck() {
      if (this.selectArr.length === 0) {
        this.$message.error('请先选择会话记录');
        return;
      }
      this.dialogVisible = true;
    },
    async dialogSure(form) {
      const obj = Object.assign(form, { id_array: this.selectArr });
      const { data } = await batchSaveCheckResult(obj);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('操作成功');
      this.closeDialog();
      this.getList(this.listQuery);
    },
    closeDialog() {
      this.selectArr = [];
      this.dialogVisible = false;
      this.$refs.dialog.resetForm();
    },
    // 点击超时配置
    overTimeSet() {
      // 点击超时配置跳转到超时配置页面
      // console.log('超时配置')
      this.$router.push({ path: '/overTimeSet' });
    },
    // 点击更新超时状态
    updateOverTime() {
      // 点击更新超时状态 给一个二次确认的弹窗
      console.log('更新超时状态');
    },
  },
};
</script>